// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__bJXVv","footer":"ReportModalFilter_footer__2cRjr"};